var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtcAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / ETC_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.5199653%",
    y1: "36.4430904%",
    x2: "111.948785%",
    y2: "87.0993184%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D57AC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F448C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "57.5508452%",
    y1: "91.566132%",
    x2: "41.479989%",
    y2: "19.6777344%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.867132867,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.4509968%",
    y1: "91.566132%",
    x2: "38.2075972%",
    y2: "19.6777344%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.867132867,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.7668782%",
    y1: "91.566132%",
    x2: "37.8511719%",
    y2: "19.6777344%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF",
    stopOpacity: 0.867132867,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-ETC_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ETC",
    transform: "translate(0.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.42108547e-14,-8.52651283e-14 L-1.42108547e-14,53 L90,53 L90,-8.52651283e-14 L-1.42108547e-14,-8.52651283e-14 Z M86,49 L4,49 L4,4 L86,4 L86,49 Z",
    id: "Frame---Fill",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "E---Fill",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    points: "29 36 17.5 36 17.5 29 28 29 28 24 17.5 24 17.5 17 29 17 29 12 12 12 12 41 29 41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "T---Fill",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    points: "40.2927276 41 45.7419026 41 45.75 17 53 17 53 12 33 12 33 17 40.25 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.183723,38.2394006 C58.9965079,39.4098191 60.1168882,40.2467201 61.5489378,40.7459605 C62.9769134,41.249344 64.8000776,41.5 67.0184305,41.5 C68.8864099,41.5 70.4467941,41.2907748 71.6893976,40.8702527 C72.9320012,40.4497307 73.9342322,39.795125 74.6940537,38.9126502 C75.4579494,38.0301754 76.0120283,36.8887585 76.3583277,35.4904709 C76.7066641,34.0901119 76.9185178,32.4121668 77,30.4545643 L71.6710641,30.4545643 C71.6160636,31.7347742 71.5142109,32.7933297 71.3675429,33.6343737 C71.220875,34.4774893 70.9723543,35.1507388 70.6260549,35.6499793 C70.2777185,36.1533628 69.8173441,36.5055241 69.2428946,36.7106063 C68.668445,36.9136169 67.9289941,37.0151222 67.0184305,37.0151222 C65.8695315,37.0151222 64.9467456,36.9053308 64.2521098,36.6878194 C63.5574741,36.4723795 63.0217286,35.9979975 62.6509846,35.2605303 C62.2761665,34.5272062 62.0276457,33.4562215 61.9074595,32.0434332 C61.7893103,30.6306449 61.7281987,28.7269024 61.7281987,26.3363486 C61.7281987,24.2461677 61.7893103,22.5557934 61.9074595,21.2610827 C62.0276457,19.9705151 62.2761665,18.9782489 62.6509846,18.2863555 C63.0237656,17.5965336 63.5574741,17.1325093 64.2521098,16.9025687 C64.9467456,16.6705566 65.8695315,16.5545505 67.0184305,16.5545505 C67.9289941,16.5545505 68.668445,16.6498412 69.2428946,16.8404226 C69.8173441,17.0330755 70.2777185,17.3707361 70.6260549,17.8596188 C70.9723543,18.3505731 71.2188379,19.0010358 71.3675429,19.8172214 C71.5142109,20.633407 71.6160636,21.6650325 71.6710641,22.9141693 L77,22.9141693 C76.9185178,20.9317083 76.7453681,19.2268333 76.4785139,17.7995443 C76.2116597,16.3743268 75.7248036,15.1935506 75.0179455,14.2530728 C74.3070133,13.3146665 73.3190416,12.6207016 72.0499563,12.1732496 C70.7808711,11.7257975 69.1043748,11.5 67.0204676,11.5 C64.9100786,11.5 63.1459889,11.7257975 61.7302357,12.1732496 C60.3144825,12.6207016 59.185954,13.4037426 58.3446503,14.5182295 C57.5033466,15.6327165 56.9003783,17.1511532 56.5418566,19.0818257 C56.1792608,21.0124983 56,23.456912 56,26.4192101 C56,29.2717166 56.1609273,31.6622704 56.4787079,33.592943 C56.8025997,35.5236155 57.368901,37.0731253 58.183723,38.2394006 Z",
    id: "C---Fill",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0204676,12.51 C68.9634773,12.51 70.5297725,12.7082045 71.7141154,13.1257782 C72.7785168,13.5010631 73.6152862,14.0741623 74.2105639,14.8598964 C74.8331064,15.688192 75.2511041,16.7321401 75.4857171,17.9851633 C75.6965997,19.1130844 75.8461789,20.4194931 75.9372849,21.9041693 L75.9372849,21.9041693 L72.6254984,21.9041693 C72.563784,21.0246635 72.474967,20.269349 72.3611856,19.6361846 C72.1813179,18.648959 71.8691474,17.8697103 71.4486139,17.273533 C70.9738637,16.6072311 70.3473147,16.145526 69.5609299,15.881802 C68.9043504,15.6639728 68.0605475,15.5445505 67.0184305,15.5445505 C65.735076,15.5445505 64.7071219,15.6857438 63.9347139,15.9437362 C62.99691,16.2541711 62.267293,16.8719415 61.7629226,17.8052673 C61.3390493,18.5877137 61.0380504,19.704481 60.9016388,21.1692963 C60.7813529,22.4874219 60.7181987,24.2083315 60.7181987,26.3363486 C60.7181987,28.7621898 60.7810812,30.6939793 60.9010944,32.1290449 C61.0356064,33.710232 61.3330505,34.9012197 61.7485993,35.714183 C62.2575129,36.7264909 63.004898,37.3584608 63.9502988,37.6516711 C64.7207207,37.8929134 65.7428753,38.0251222 67.0184305,38.0251222 C68.0683595,38.0251222 68.9180742,37.8966131 69.5824792,37.6618067 C70.3608316,37.3839299 70.9846135,36.9067633 71.4559464,36.2256355 C71.8718883,35.6259953 72.1859519,34.8229228 72.3625269,33.8078869 C72.4766008,33.1537483 72.5655529,32.3732961 72.6271232,31.4645643 L72.6271232,31.4645643 L75.9323007,31.4645643 C75.8309222,32.8998952 75.6483557,34.1605861 75.3779463,35.24767 C75.0747914,36.4717488 74.6002964,37.477757 73.9286698,38.2536453 C73.2812243,39.005604 72.4228732,39.5557606 71.365631,39.9135526 C70.2091582,40.3049262 68.7556826,40.49 67.0184305,40.49 C64.9377903,40.49 63.2250336,40.2658924 61.8814186,39.7922538 C60.6630807,39.3675174 59.7055391,38.6601225 59.0116707,37.6609523 C58.2694602,36.5986076 57.7693401,35.1816201 57.4752984,33.4289084 C57.1647842,31.5423826 57.01,29.2063317 57.01,26.4192101 C57.01,23.5324458 57.1811191,21.1498709 57.5348802,19.266228 C57.859198,17.5197465 58.388258,16.136839 59.1507582,15.1267441 C59.8669311,14.1780197 60.8306917,13.516796 62.0346085,13.1362953 C63.3689066,12.7145874 65.0324957,12.51 67.0204676,12.51 Z",
    id: "C---Border",
    strokeOpacity: 0.332167832,
    stroke: "#FFFFFF",
    strokeWidth: 2.02,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.99,13.01 L51.99,15.99 L44.7403407,15.99 L44.7322433,39.99 L41.3009311,39.99 L41.2582035,15.99 L34.01,15.99 L34.01,13.01 L51.99,13.01 Z",
    id: "T---Border",
    strokeOpacity: 0.332167832,
    stroke: "#FFFFFF",
    strokeWidth: 2.02,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.01,13.01 L27.99,13.01 L27.99,15.99 L16.49,15.99 L16.49,25.01 L26.99,25.01 L26.99,27.99 L16.49,27.99 L16.49,37.01 L27.99,37.01 L27.99,39.99 L13.01,39.99 L13.01,13.01 Z",
    id: "E---Border",
    strokeOpacity: 0.332167832,
    stroke: "#FFFFFF",
    strokeWidth: 2.02,
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtcAppTile);
export default __webpack_public_path__ + "static/media/ETC_app_tile.5d19cc5c12023fa4a7c11244132a11d5.svg";
export { ForwardRef as ReactComponent };